/**
 * Is value just string of numbers
 * @param {string} stringNumber
 * @returns {boolean}
 */
export const isStringNumber = (stringNumber) => {
  const regex = new RegExp(/^[0-9]+$/)
  return regex.test(stringNumber)
}
